import React, { forwardRef } from "react";
import "../../../../../assets/styles/judgeSheet.scss";

// Short form用テンプレート（Musicality_Judging_short_Form.png 等）。
// 通常版（JudgingSheetTemplate.tsx）と画像上の文字の配置位置が異なるため、
// あえて別ファイル・別クラス名（judging-sheet-shortform-page-*）にしている。
//
// 1枚の画像に2グループ分を印字する：
// 上半分（judging-sheet-shortform-page-*）＝topGroup、
// 下半分（judging-sheet-shortform-reflect内、上下反転）＝bottomGroup。
export const SHEET_WIDTH_SHORT_FORM = 1836;
export const SHEET_HEIGHT_SHORT_FORM = 2376;

export interface JudgingSheetTemplateShortFormProps {
  imageSrc: string;
  entryClassLabel: string;
  dateStr: string;
  judgeName: string;
  judgeNumber: number; // Judge Panel の #1・#2・#3
  topEntryNumber: number | string | undefined;
  topGroupName: string;
  // 対になる2件目のグループがない場合（件数が奇数の最後の1件など）は省略する
  bottomEntryNumber?: number | string | undefined;
  bottomGroupName?: string;
}

const getTopBarFontSize = (name: string) => {
  if (name.length > 30) return 22;
  if (name.length > 20) return 26;
  return 30;
};

const JudgingSheetTemplateShortForm = forwardRef<
  HTMLDivElement,
  JudgingSheetTemplateShortFormProps
>(
  (
    {
      imageSrc,
      entryClassLabel,
      dateStr,
      judgeName,
      judgeNumber,
      topEntryNumber,
      topGroupName,
      bottomEntryNumber,
      bottomGroupName,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className="judging-sheet-shortform-page"
        style={
          {
            "--sheet-width": `${SHEET_WIDTH_SHORT_FORM}px`,
            "--sheet-height": `${SHEET_HEIGHT_SHORT_FORM}px`,
          } as React.CSSProperties
        }
      >
        <img
          src={imageSrc}
          alt=""
          width={SHEET_WIDTH_SHORT_FORM}
          height={SHEET_HEIGHT_SHORT_FORM}
          className="judging-sheet-shortform-page-image"
        />

        {/* 上半分：1件目のグループ */}
        <div className="judging-sheet-shortform-page-topbar-title">
          {entryClassLabel}　|　{dateStr}
        </div>
        <div
          className="judging-sheet-shortform-page-topbar-left"
          style={{ fontSize: getTopBarFontSize(topGroupName) }}
        >
          No.{topEntryNumber ?? "-"} {topGroupName}
        </div>

        <div className="judging-sheet-shortform-page-topbar-right">
          {judgeName} #{judgeNumber}
        </div>

        <div className="judging-sheet-shortform-page-divider" />

        {/* 下半分：2件目のグループ（上下反転して表示） */}
        {bottomGroupName && (
          <div className="judging-sheet-shortform-reflect">
            <div className="judging-sheet-shortform-page-topbar-title">
              {entryClassLabel}　|　{dateStr}
            </div>
            <div
              className="judging-sheet-shortform-page-topbar-left"
              style={{ fontSize: getTopBarFontSize(bottomGroupName) }}
            >
              No.{bottomEntryNumber ?? "-"} {bottomGroupName}
            </div>

            <div className="judging-sheet-shortform-page-topbar-right">
              {judgeName} #{judgeNumber}
            </div>

            <div className="judging-sheet-shortform-page-divider" />
          </div>
        )}
      </div>
    );
  },
);

JudgingSheetTemplateShortForm.displayName = "JudgingSheetTemplateShortForm";

export default JudgingSheetTemplateShortForm;
